var _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _path3, _path4, _polygon5, _polygon6, _polygon7, _polygon8, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamsungIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8c9eff",
    d: "M42,10v28c0,1.1-0.45,2.1-1.17,2.83C40.1,41.55,39.1,42,38,42H10c-2.21,0-4-1.79-4-4V10 c0-1.1,0.45-2.1,1.17-2.83C7.9,6.45,8.9,6,10,6h28C40.21,6,42,7.79,42,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1de9b6",
    d: "M42,10v2l-6-6h2C40.21,6,42,7.79,42,10z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1ee4bc",
    points: "42,12 42,18 30,6 36,6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1fe0c2",
    points: "42,18 42,24 24,6 30,6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#20dbc7",
    points: "42,24 42,30 18,6 24,6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#21d6cd",
    points: "42,30 42,36 12,6 18,6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#22d2d3",
    d: "M42,36v2c0,1.1-0.45,2.1-1.17,2.83L7.17,7.17C7.9,6.45,8.9,6,10,6h2L42,36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#24cdd9",
    d: "M40.83,40.83C40.1,41.55,39.1,42,38,42h-2L6,12v-2c0-1.1,0.45-2.1,1.17-2.83L40.83,40.83z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#25c9df",
    points: "36,42 30,42 6,18 6,12"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#26c4e5",
    points: "30,42 24,42 6,24 6,18"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#27bfea",
    points: "24,42 18,42 6,30 6,24"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#28bbf0",
    points: "18,42 12,42 6,36 6,30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#29b6f6",
    d: "M12,42h-2c-2.21,0-4-1.79-4-4v-2L12,42z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.43,37c-1.457,0-3.279-0.182-4.736-1.093c-1.457-0.911-5.282-3.825-5.829-4.189 c-0.546-0.364-1.639-1.457,0-3.096c1.639-1.639,5.282-5.646,5.829-6.193s1.457-1.093,3.096-0.729 c0.182-0.729,0.182-2.55-0.729-3.643c-1.093,0.729-2.732,4.007-4.554,4.007c-1.457,0-2.368-0.911-2.732-1.457 c0.546,0.182,1.093,0,2.004-1.093c0.911-1.093,2.004-2.004,4.918-1.821c-0.546-1.093-0.546-1.821-0.546-2.55 c0-0.729,0.911-3.643,4.007-3.643c2.732,0,4.007,2.186,4.007,2.914c0,0.729,0,2.004,0,2.186c0,0.182,0.364,0.182,0.364,0.546 c0,0.364,0,1.639-0.364,2.368c-0.182,0.364-0.546,0.546-0.911,0.546s-0.911,0-0.911,0l-0.546,3.096c0,0,2.368,1.639,2.368,3.643 s0,5.829,0,5.829l3.643-2.732c-0.182-0.364-0.729-1.639-0.182-2.368c0.546-0.729,1.275-0.911,1.639-0.911 c0.364,0,0.729,0.364,0.729,0.911s0,2.004,0,2.368c0,0.364,0,0.546-0.364,0.911c-0.364,0.364-4.007,4.189-4.736,4.736 S27.162,37,24.43,37z M20.423,33.357l-1.093-5.464l-2.55,2.004L20.423,33.357z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamsungIcon);
export default __webpack_public_path__ + "static/media/samsung-icon.4c145e60a149b90303be7bce911c3802.svg";
export { ForwardRef as ReactComponent };